import { defineStore, storeToRefs } from 'pinia'
import { useClockStore } from './clock.js'
import { useMysterySoundGuessStore } from './mysterySoundGuess.js'

export const useLastVoteStore = defineStore('last_vote', {
  state: () => ({
    time: null,
    id: null,
  }),

  actions: {
    initilize() {
      let lastVote

      try {
        lastVote = JSON.parse(localStorage.getItem('last_vote'))
      } catch (e) {
        console.error('Error parsing last_vote from localStorage:', e)
        return
      }

      if (!lastVote) {
        return
      }

      this.time = parseInt(lastVote.time, 10)
      this.id = lastVote.id
    },

    storeVote(id) {
      const time = Date.now() / 1000

      this.time = time
      this.id = id

      try {
        localStorage.setItem('last_vote', JSON.stringify({ time, id }))
      } catch (e) {
        console.error('Error storing last_vote in localStorage:', e)
      }
    },
  },

  getters: {
    alreadyVoted(state) {
      const clock = useClockStore()
      const { now } = storeToRefs(clock)

      const lastVote = new Date(state.time * 1000)

      return (
        lastVote.getDate() === now.value.getDate() &&
        lastVote.getMonth() === now.value.getMonth() &&
        lastVote.getFullYear() === now.value.getFullYear()
      )
    },

    votedOnActiveGuess(state) {
      if (!this.alreadyVoted) {
        return false
      }

      const mysterySoundStore = useMysterySoundGuessStore()
      const { id } = storeToRefs(mysterySoundStore)

      return state.id === id.value
    },
  },
})
